import { useState } from "react";
import { useAppSelector } from "../../store/hooks";
import { useGetQuery } from "../../store/slices/apiSlice";
import { System, UnitMeasure, CurveMeasure } from "../../store/types";

interface UnitsProps {
  fetchSystems?: boolean;
  fetchMeasures?: boolean;
  fetchConvertFormula?: boolean;
  fetchCurveMeasure?: boolean;
  fetchCurveConvertFormula?: boolean;
  unitSystemId?: string;
  unitName?: string;
  curveName?: string;
}

export const useUnitsAPI = ({
  fetchSystems = false,
  fetchMeasures = false,
  fetchConvertFormula = false,
  fetchCurveMeasure = false,
  fetchCurveConvertFormula = false,
  unitSystemId,
  unitName,
  curveName,
}: UnitsProps) => {
  const systemsEP = useAppSelector((state) => state.endpoints.systems);
  const measuresEP = useAppSelector((state) => state.endpoints.measures);
  const unitsEP = useAppSelector((state) => state.endpoints.units);
  const convertFormulaEP = useAppSelector(
    (state) => state.endpoints.convertFormula
  );

  const {
    data: systems,
    refetch: refetchSystems,
    isLoading: isSystemsLoading,
  } = useGetQuery(systemsEP, {
    refetchOnMountOrArgChange: true,
    skip: !fetchSystems || !systemsEP,
  });

  const {
    data: measures,
    refetch: refetchMeasures,
    isLoading: isMeasuresLoading,
  } = useGetQuery(measuresEP, {
    refetchOnMountOrArgChange: true,
    skip: !fetchMeasures || !measuresEP,
  });

  const {
    data: convertFormula,
    refetch: refetcConvertFormula,
    isLoading: isConvertFormulaLoading,
  } = useGetQuery(`${unitsEP}${convertFormulaEP}`, {
    refetchOnMountOrArgChange: true,
    skip: !fetchConvertFormula || !convertFormulaEP || !unitsEP,
  });

  const {
    data: curveMeasure,
    refetch: refetchCurveMeasure,
    isLoading: isCurveMeasureLoading,
  } = useGetQuery(`${systemsEP}/${unitSystemId}/curve/${curveName}/measure`, {
    refetchOnMountOrArgChange: true,
    skip: !fetchCurveMeasure || !unitSystemId || !curveName || !systemsEP,
  });

  const {
    data: curveConvertFormula,
    refetch: refetchCurveConvertFormula,
    isLoading: isCurveConvertFormulaLoading,
  } = useGetQuery(
    `${systemsEP}/${unitSystemId}/curve/${curveName}${convertFormulaEP}?fromLabel=${unitName}`,
    {
      refetchOnMountOrArgChange: true,
      skip:
        !fetchCurveConvertFormula ||
        !unitSystemId ||
        !curveName ||
        !unitName ||
        !systemsEP ||
        !convertFormulaEP,
    }
  );

  return {
    systems: systems as System[] | undefined,
    refetchSystems,
    isSystemsLoading,
    measures: measures as UnitMeasure[] | undefined,
    refetchMeasures,
    isMeasuresLoading,
    convertFormula: convertFormula as string | undefined,
    refetcConvertFormula,
    isConvertFormulaLoading,
    curveMeasure: curveMeasure as CurveMeasure | undefined,
    refetchCurveMeasure,
    isCurveMeasureLoading,
    curveConvertFormula: curveConvertFormula as string | undefined,
    refetchCurveConvertFormula,
    isCurveConvertFormulaLoading,
  };
};
